import type { User, UserPermission } from "../types.ts";

export const isUserAllowedTo = (user: User, permission: UserPermission) =>
  user.permissions.includes(permission);
